module.exports = __webpack_public_path__ + "img/gifted.6f9d3455.svg";